import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_opa_commission_api = async () => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/configs`
	);
	return response.data;
};

export const add_opa_commission_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/configs`,
		body
	);
	return response.data;
};

export const get_contact_details_api = async () => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/configs`
	);
	return response.data;
};

// Mobile app versions and the per-platform Force Update switches (auth-service).
export const get_mobile_configs_api = async () => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.AUTH}/configs/mobile`
	);
	return response.data;
};

// body: { platform: "android" | "ios", enabled: boolean, min_required_version?: string }
export const update_mobile_force_update_api = async (body) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.AUTH}/configs/mobile/force-update`,
		body
	);
	return response.data;
};

export const update_contact_details_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/configs`,
		body
	);
	return response.data;
};
